import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Footer } from '../components/Footer';

export function LoginPage() {
    const { isAuthenticated, isLoading, login } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, navigate]);

    if (isLoading) {
        return (
            <div className="login-page login-page--loading">
                <div className="login-loading">
                    <div className="spinner" />
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <header className="login-header">
                <a
                    href="https://theaamgroup.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="login-header-link"
                >
                    <img
                        src="/aam/aam-logo-white.png"
                        alt="The AAM Group"
                        className="login-header-logo"
                    />
                </a>
            </header>

            <div className="login-hero">
                <p className="login-tagline">We exist to grow our industry.</p>

                <div className="login-card">
                    <img
                        src="/logo.png"
                        alt="AAM Let's Meet"
                        className="login-logo"
                    />

                    <p className="login-description">
                        Schedule meetings with ease. Propose times, collect responses, find the perfect slot.
                    </p>

                    <button
                        type="button"
                        onClick={login}
                        className="login-button"
                    >
                        Sign in with Insight
                    </button>

                    <p className="login-hint">
                        Use your AAM Group credentials to sign in
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    );
}
